module.exports = __webpack_public_path__ + "static/media/currentSubscription.1d098f29.svg";